import * as Yup from 'yup';

export const addScenarioValidationSchema = Yup.object().shape({
  title: Yup.string()
    .required('Title is required')
    .min(3, 'Title must be at least 3 characters')
    .max(100, 'Title must not exceed 100 characters'),
  amount: Yup.number()
    .required('Amount is required')
    .min(0, 'Amount must be positive')
    .max(10000, 'Amount must not exceed $10,000'),
  description: Yup.string()
    .required('Description is required')
    .min(10, 'Description must be at least 10 characters')
    .max(500, 'Description must not exceed 500 characters'),
});
